// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderPage_container__8JHek"};